export enum PersistedQueryListConfigStep {
  MetaNameDesc = 'Create',
  Link = 'Link',
  Publish = 'Publish',
  Configure = 'Configure',
}

export enum PersistedQueryListConfigWorkflow {
  create = 'create',
}

const PQCreateWorkflowSteps = [
  PersistedQueryListConfigStep.MetaNameDesc,
  PersistedQueryListConfigStep.Link,
  PersistedQueryListConfigStep.Publish,
  PersistedQueryListConfigStep.Configure,
];

export const getPQConfigWorkflowSteps = (
  workflow: PersistedQueryListConfigWorkflow = PersistedQueryListConfigWorkflow.create,
): Array<PersistedQueryListConfigStep> => {
  switch (workflow) {
    default:
      return PQCreateWorkflowSteps;
  }
};
